/*
 * @Author:
 * @LastEditTime: 2022-03-18 09:20:00
 * @Description:
 */
import To from 'await-to-js'
// import encodeUrl from 'encodeurl'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinPoint = {
  async apiPoint(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'list':
        RecordOperation({
          type: 'query',
        })
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/std/MeasuringPoint/?${qs.stringify(arg.params)}`)
        )
        break
      case 'detail':
        RecordOperation({
          type: 'detail',
        })
        ;[err, res] = await To(wizStandardInstance.get(`/api/std/MeasuringPoint/${arg.params.id}`))
        break
      case 'add':
        RecordOperation({
          type: 'create',
        })
        ;[err, res] = await To(wizStandardInstance.post('/api/std/MeasuringPoint', arg.params))
        break
      case 'edit':
        RecordOperation({
          type: 'update',
        })
        ;[err, res] = await To(
          wizStandardInstance.put(`/api/std/MeasuringPoint/${arg.params.id}`, arg.params)
        )
        break
      // 批量删除测点
      case 'delete':
        RecordOperation({
          type: 'delete',
        })
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/std/MeasuringPoint/many', { data: arg.params.ids })
        )
        break
      case 'upload':
        RecordOperation({
          type: 'import',
        })
        ;[err, res] = await To(
          wizStandardInstance.post('/api/std/MeasuringPoint/import', arg.formData, {
            responseType: 'blob',
          })
        )
        break
      case 'download':
        RecordOperation({
          type: 'export',
        })
        ;[err, res] = await To(
          wizStandardInstance.post('/api/std/MeasuringPoint/export', arg.params, {
            responseType: 'blob',
          })
        )
        break
      case 'template':
        RecordOperation({
          type: 'export',
        })
        ;[err, res] = await To(
          wizStandardInstance.get('/api/std/MeasuringPoint/download-template', {
            responseType: 'blob',
          })
        )
        break
      default:
        console.log('no this method')
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinPoint,
}
